import axiosInstance from "../config/axios.config";

export const getPatientDetailsApi = (id) => {
  return axiosInstance.get(`/inpatient/patient-details/${id}/`);
};

export const submitReferralFormApi = (payload) => {
  return axiosInstance.post("inpatient/referral-form/", payload);
};
export const getReferralFormApi = (id) => {
  return axiosInstance.get(`inpatient/referral-form/${id}/`);
};
export const updateReferralFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/referral-form/${id}/`, payload);
};
export const submitDeathFormApi = (payload) => {
  return axiosInstance.post("inpatient/death-form/", payload);
};
export const getDeathFormApi = (id) => {
  return axiosInstance.get(`inpatient/death-form/${id}/`);
};
export const updateDeathFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/death-form/${id}/`, payload);
};
export const submitInvestigationFormApi = (payload) => {
  return axiosInstance.post("inpatient/investigation-referral-form/", payload);
};
export const getInvestigationFormApi = (id) => {
  return axiosInstance.get(`inpatient/investigation-referral-form/${id}/`);
};
export const updateInvestigationFormApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/investigation-referral-form/${id}/`,
    payload
  );
};
export const submitReviewFormApi = (payload) => {
  return axiosInstance.post("inpatient/review-form/", payload);
};
export const getListReviewFormApi = (id) => {
  return axiosInstance.get(`inpatient/review-form/?ip_admission=${id}`);
};
export const getReviewFormApi = (id) => {
  return axiosInstance.get(`inpatient/review-form/${id}/`);
};
export const updateReviewFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/review-form/${id}/`, payload);
};
export const printFormApi = (params) => {
  return axiosInstance.post(`inpatient/print-form/?${params}`);
};
export const getListNutritionistReassessmentFormApi = (id) => {
  return axiosInstance.get(
    `inpatient/nutrition-reassessment/?admission_id=${id}`
  );
};
export const getNutritionistReassessmentFormApi = (id) => {
  return axiosInstance.get(`inpatient/nutrition-reassessment/${id}/`);
};
export const submitNutritionistReassessmentFormApi = (payload) => {
  return axiosInstance.post("inpatient/nutrition-reassessment/", payload);
};
export const updateNutritionistReassessmentFormApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nutrition-reassessment/${id}/`,
    payload
  );
};
